<template>
    <div class='comment_box cb mt-10'>
        <div v-if="reply_info">
            <span v-html="reply_associated_with"></span>
            <i class="fa fa-info-circle info" v-bind:title="reply_info"></i>
        </div>
        <form class="relative-position" v-on:submit="onSubmit" v-bind:class="{'pt-10': reply_info}">
            <textarea class="comment-reply" v-model="commentReply" required></textarea>
            <div class="clearfix"></div>
            <br>
            <div v-show="!acceptedTermsAfter" class="alert alert-danger mb-15">
                <strong class="text-danger" v-text="accept_terms_text"></strong>
            </div>
            <div class="profile-select-button pull-left">
                <input v-model="acceptedTerms" type="checkbox" value="1" id="accept-terms-conditions">
                <label for="accept-terms-conditions"><i class="fa fa-check"></i></label>
                <p v-html="terms_text"></p>
            </div>
            <div class="pull-right pl-10">
                <button class="btn btn-submit" v-text="send_text" type="submit" v-bind:disabled="buttonDisabled"></button>
                <button class="btn btn-default ml-10" v-text="cancel_text" v-on:click="cancel"></button>
            </div>
        </form>
    </div>
</template>

<script>
    export default {
        props: [
            'reply_associated_with', 'reply_info', 'comment', 'send_text', 'cancel_text', 'save_url', 'id_element',
            'terms_text', 'accept_terms_text'
        ],
        data: function () {
            return {
                buttonDisabled: false,
                commentReply: this.comment ? this.comment.replace(/<br \/>|<br\/>|<br>/g, "\n") : '',
                acceptedTerms: false,
                acceptedTermsAfter: true
            }
        },
        methods: {
            onSubmit: function (e) {
                e.preventDefault();
                this.acceptedTermsAfter = true;
                if (this.acceptedTerms === false) {
                    this.acceptedTermsAfter = false;
                    return false;
                }
                if (!this.buttonDisabled) {
                    this.buttonDisabled = true;
                    axios.post(this.save_url, {
                        id: this.id_element,
                        value: this.commentReply
                    })
                    .then((response) => {
                        this.$emit('saved', response.data);
                        this.buttonDisabled = false;
                        this.commentReply   = '';
                        this.reply          = false;
                    })
                    .catch((error) => {
                        this.buttonDisabled = false;
                    });
                }
            },
            cancel: function () {
                this.$emit('cancel', true);
            }
        }
    }
</script>
